import React from 'react'

class ThemeOption extends React.Component {
    getDisplayStyle() {
        var nameStyle = {
            fontWeight: this.props.theme.weight,
            fontFamily: this.props.theme.family + ',' + this.props.theme.fontWithFallbacks,
            fontSize: parseInt(this.props.theme.size, 10) <= 28 ? this.props.theme.size : '28px',
            fontStyle: this.props.theme.style
        }

        return nameStyle
    }

    render() {
        return (
            <div className="style-option">
                <div className="style-option-header">
                    <div className="style-color-container">
                        <span className="style-color" style={{backgroundColor: this.props.theme.cssColor}}></span>
                    </div>
                    <span className="style-name" style={this.getDisplayStyle()}>{this.props.translate(this.props.name)}</span>
                </div>
                <div className="style-option-footer">
                    <span className="style-size">{this.props.theme.size}</span>
                    <span className="style-tag">&lt;{this.props.theme.tag}&gt;</span>
                </div>
                <div className="style-option-label">
                    <span className="display-name">{this.props.translate(this.props.name)}</span>
                    <span className="custom-style-indicator">*</span></div>
            </div>
        )
    }
}

ThemeOption.propTypes = {
    theme: React.PropTypes.object.isRequired,
    name: React.PropTypes.string.isRequired,
    translate: React.PropTypes.func.isRequired
}

module.exports = ThemeOption



// WEBPACK FOOTER //
// ./src/components/toolbar/themeOption.jsx